import { Button } from "~/atoms/button";

export const TestErrorButton = () => {
  return (
    <Button
      variant="destructive"
      onClick={() => {
        throw new Error("Test Error");
      }}
      // eslint-disable-next-line i18next/no-literal-string
    >
      Test error
    </Button>
  );
};
